import { render, staticRenderFns } from "./Pinglun.vue?vue&type=template&id=082024a2&scoped=true&"
import script from "./Pinglun.vue?vue&type=script&lang=js&"
export * from "./Pinglun.vue?vue&type=script&lang=js&"
import style0 from "./Pinglun.vue?vue&type=style&index=0&id=082024a2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082024a2",
  null
  
)

export default component.exports